<!-- src/app/pages/coalitions/coalitions.component.html -->
<section class="coalitions-page">
  <div class="container">

    <!-- HERO -->
    <div class="hero">
      <h1>Coalitions</h1>
      <p class="hero-sub">
        Michigan is made up of communities, not voting blocs. Find yours and join the movement.
      </p>
    </div>

    <!-- COALITION CARDS -->
    <div class="coalition-grid">
      <div
        *ngFor="let c of coalitions"
        class="coalition-card"
        [class.coalition-card--active]="activeCard === c.id"
      >
        <div class="coalition-card__header" (click)="toggleCard(c.id)">
          <span class="coalition-card__icon">{{ c.icon }}</span>
          <div class="coalition-card__titles">
            <h2>{{ c.name }}</h2>
            <p class="coalition-card__tagline">{{ c.tagline }}</p>
          </div>
          <span class="coalition-card__chevron">{{ activeCard === c.id ? '▲' : '▼' }}</span>
        </div>

        <div class="coalition-card__body" *ngIf="activeCard === c.id">
          <p class="coalition-card__desc">{{ c.description }}</p>
          <div class="coalition-card__why">
            <strong>Why Lydia:</strong> {{ c.why }}
          </div>
          <button class="btn-join" (click)="scrollToJoin(c.id)">
            Join {{ c.name }}
          </button>
        </div>
      </div>
    </div>

    <!-- JOIN FORM -->
    <div class="join-section" id="join-form">
      <h2>Join a Coalition</h2>
      <p class="join-intro">
        Add your name to a coalition. We'll keep you updated on events, actions,
        and opportunities specific to your community.
      </p>

      <form
        #joinForm="ngForm"
        (ngSubmit)="onSubmit()"
        *ngIf="!submitted"
        class="join-form"
      >
        <div class="form-group">
          <label for="j-coalition">Which coalition are you joining? *</label>
          <select id="j-coalition" name="coalition" required
            [(ngModel)]="selectedCoalition" #jCoalition="ngModel">
            <option value="">Select a coalition</option>
            <option *ngFor="let c of coalitions" [value]="c.id">
              {{ c.icon }} {{ c.name }}
            </option>
          </select>
          <div *ngIf="jCoalition.invalid && jCoalition.touched" class="error">Please select a coalition.</div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="j-name">Full Name *</label>
            <input id="j-name" name="name" type="text" placeholder="Full Name"
              required [(ngModel)]="form.name" #jName="ngModel"
              [disabled]="submitting" />
            <div *ngIf="jName.invalid && jName.touched" class="error">Name is required.</div>
          </div>
          <div class="form-group">
            <label for="j-email">Email Address *</label>
            <input id="j-email" name="email" type="email" placeholder="Email Address"
              required pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
              [(ngModel)]="form.email" #jEmail="ngModel"
              [disabled]="submitting" />
            <div *ngIf="jEmail.invalid && jEmail.touched" class="error">
              <span *ngIf="jEmail.errors?.['required']">Email is required.</span>
              <span *ngIf="jEmail.errors?.['pattern']">Enter a valid email.</span>
            </div>
          </div>
          <div class="form-group">
            <label for="j-zip">ZIP Code *</label>
            <input id="j-zip" name="zip" type="text" placeholder="ZIP Code"
              required pattern="\d{5}"
              [(ngModel)]="form.zip" #jZip="ngModel"
              [disabled]="submitting" />
            <div *ngIf="jZip.invalid && jZip.touched" class="error">
              <span *ngIf="jZip.errors?.['required']">ZIP is required.</span>
              <span *ngIf="jZip.errors?.['pattern']">Enter a 5-digit ZIP.</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="j-message">Why are you joining? <span class="optional">(optional)</span></label>
          <textarea id="j-message" name="message" rows="3"
            placeholder="Tell us what motivates you - we'd love to hear."
            [(ngModel)]="form.message" [disabled]="submitting"></textarea>
        </div>

        <button type="submit" class="btn-primary"
          [disabled]="joinForm.invalid || submitting">
          {{ submitting ? 'Joining...' : 'Join the Coalition' }}
        </button>
        <div *ngIf="error" class="error submit-error">{{ error }}</div>
      </form>

      <div *ngIf="submitted" class="success-message">
        <div class="success-icon">★</div>
        <h3>Welcome to {{ selectedCoalitionName }}!</h3>
        <p>You're part of the movement. We'll be in touch with actions, events, and updates for your coalition.</p>
        <div class="success-actions">
          <button class="btn-secondary" (click)="reset()">Join Another Coalition</button>
          <a routerLink="/volunteer" class="btn-primary">Volunteer Too</a>
        </div>
      </div>
    </div>

  </div>
</section>
